import React, { useEffect, useState ,useCallback} from 'react'
import useStyles from './style'
import {
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Collapse,
  Typography,
} from '@mui/material'
import {
  ChevronLeftRounded,
  ChevronRightRounded,
  DashboardOutlined,
  FolderOutlined,
  DirectionsCarOutlined,
  AccountTreeOutlined,
  BuildOutlined,
  AssessmentOutlined,
  AccountBalanceWalletOutlined,
  ForumOutlined,
  SettingsOutlined,
  AutorenewOutlined,
  LogoutOutlined,
} from "@mui/icons-material";
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import list from '../../Model/MenuList'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { toggleSidebar } from '../../Redux/Sidebar/actions'
import settingsApi from "Services/Settings";
import logo from "../../assets/IconMetuaa.png";
// Redux
import { showSnackbar } from "../../Redux/SnackBar/actions";
import { setNewSiteLogo } from "../../Redux/SiteSettings/actions";

const Sidebar = ({profileDetails}) => {
  const classes = useStyles()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const dispatch = useDispatch();
  const [selectedIndex, setSelectedIndex] = useState(pathname)
  const [menuList, setMenuList] = useState(list)
  const siteNewL = useSelector( 
    (state) => state?.SiteSettingsReducer?.siteNewLogo
  );
  const sidebarOpen = useSelector((state) => state.sidebar.isOpen);
  const userType = useSelector(
    (state) => state?.AuthReducer?.userType || ""
  );

  const getIconByName = (name = "") => {
    const n = String(name).toLowerCase();
    if (n.includes("fleet") || n.includes("vehicle") || n.includes("driver") || n.includes("programme") || n.includes("ride")) return DirectionsCarOutlined;
    if (n.includes("operation") || n.includes("zone") || n.includes("location") || n.includes("service")) return AccountTreeOutlined;
    if (n.includes("report") || n.includes("statement")) return AccountTreeOutlined;
    if (n.includes("finance") || n.includes("earning") || n.includes("cashout") || n.includes("wallet") || n.includes("bank") || n.includes("billing") || n.includes("payment")) return BuildOutlined;
    if (n.includes("engagement") || n.includes("notification") || n.includes("promo") || n.includes("rating") || n.includes("review")) return AutorenewOutlined;
    if (n.includes("setting") || n.includes("foundation") || n.includes("password") || n.includes("commission")) return SettingsOutlined;
    if (n.includes("sign out") || n.includes("logout")) return LogoutOutlined;
    if (n.includes("api") || n.includes("smtp") || n.includes("webhook")) return BuildOutlined;
    return FolderOutlined;
  };

  const topLevelIconSet = [
    FolderOutlined,
    DirectionsCarOutlined,
    AccountTreeOutlined,
    BuildOutlined,
    AutorenewOutlined,
  ];

  const getTopLevelIcon = (name = "", index = 0) => {
    const n = String(name).toLowerCase();
    if (n.includes("dashboard")) return DashboardOutlined;
    if (n.includes("fleet")) return DirectionsCarOutlined;
    if (n.includes("user")) return AccountTreeOutlined;
    if (n.includes("operation")) return BuildOutlined;
    if (n.includes("report")) return AssessmentOutlined;
    if (n.includes("finance")) return AccountBalanceWalletOutlined;
    if (n.includes("engagement")) return ForumOutlined;
    if (n.includes("setting")) return SettingsOutlined;
    if (n.includes("sign out") || n.includes("logout")) return LogoutOutlined;
    return topLevelIconSet[index % topLevelIconSet.length];
  };

  
 const handleToggleSidebar = () => {
    dispatch(toggleSidebar());
  };

  const handleClick = (index, openState) => {
    const updatedMenuList = menuList?.filter((menu) => menu.for.includes(userType)).map((data, idx) => {
      if (data?.isCollapsible) {
        if (idx === index) {
          return { ...data, open: !openState, active: true }
        } else {
          return { ...data, open: false, active: false }
        }
      } else if (data?.link === selectedIndex) {
        return { ...data, open: openState, active: openState }
      } else {
        return { ...data, open: false, active: false }
      }
    })
    setMenuList(updatedMenuList)
  }
  // Set Settings

  const getMasterValues = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        //console.log("settings fetched ", res?.data?.data);
        dispatch(
          setNewSiteLogo(res?.data?.data?.siteLogo)
        );
      } else {
        return;
      }
    };
    const onFailure = (err) => {
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    settingsApi.getMasterValues().then(onSuccess, onFailure);
  }, [dispatch]);

  useEffect(() => {
    setSelectedIndex(pathname)
    getMasterValues();
  }, [pathname, siteNewL, getMasterValues])

  const handleMenuNavigate = (link) => {
    navigate(link)
  }

  // To Open the Active menu Collapsible True when submenu is active
  useEffect(() => {
    let currentArrObj = null
    const currentObjInMainArr = menuList?.find(
      (data) => data?.link === pathname
    )
    if (currentObjInMainArr) {
      currentArrObj = currentObjInMainArr
    } else {
      const currentObjInSubArr = menuList?.find((data) =>
        data?.subMenu?.find((item) => item?.subLink === pathname)
      )
      currentArrObj = currentObjInSubArr
    }
    const updatedMenuList = menuList?.filter((menu) => menu.for.includes(userType)).map((data) =>
      data?.name === currentArrObj?.name
        ? { ...data, open: true, active: true }
        : { ...data, open: false, active: false }
    )
    setMenuList(updatedMenuList)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  return (
    <div className={classes.sidebarShell}>

<div className={classes.brandBar}>
  <button type="button" className={classes.brandButton} onClick={() => navigate("/")}>
    <span className={classes.brandMark}>
      <img src={logo} alt="METUA'A" />
    </span>
    {sidebarOpen && (
      <span className={classes.brandText}>
        <strong>METUA&apos;A</strong>
        <small>ADMIN</small>
      </span>
    )}
  </button>

  <button type="button" className={classes.toggleButton} onClick={handleToggleSidebar} aria-label="Toggle sidebar">
    {sidebarOpen ? <ChevronLeftRounded fontSize="small" /> : <ChevronRightRounded fontSize="small" />}
  </button>
</div>

<section className={`${classes.root} ${sidebarOpen?classes.sidebarmenu:classes.sidebarmenu2}`} >

  {menuList?.filter((menu) => menu.for.includes(userType))
  .map((data, idx) => (
          <List
            key={data?.name}
            component="nav"
            aria-label="navMenu"
            onClick={() =>{
              if (data?.name === "Sign Out") {
                localStorage.clear();  // Clear storage
                navigate(0); // Reload to reset state
              } 
              data?.isCollapsible === false && handleMenuNavigate(data?.link)
            }}
          >
            <ListItemButton
              selected={data?.active === true}
              onClick={() => {
                handleClick(idx, data?.open)
              }}
            >
              <ListItemIcon>
              {React.createElement(getTopLevelIcon(data?.name, idx))}
              </ListItemIcon>
           { sidebarOpen && ( 
              <ListItemText
                primary={data?.name}
                className={
                  data?.active === true
                    ? classes.menuLabels
                    : classes.menuLabels2
                }
              />
              ) }
              {/* Accordion Icon */}
{data?.isCollapsible ? (data?.open ? (<ExpandLess />) : (<ExpandMore />)) : (<></>)}
            </ListItemButton>
            
            {/* Accordion */}
            {data?.isCollapsible === true ? (
              <Collapse in={data?.open} timeout="auto" unmountOnExit>
              {data?.subMenu?.filter((sub) => sub.for.includes(userType)).map((item, subIdx) => (
                <div key={item?.name}>
                  <List
                    component="div"
                    disablePadding
                    onClick={() => {
                      if (item?.isCollapsible) {
                        const updatedMenuList = [...menuList];
                        updatedMenuList[idx].subMenu[subIdx].open = !item.open;
                        setMenuList(updatedMenuList);
                      } else {
                        handleMenuNavigate(item?.subLink);
                      }
                    }}
                    className={classes.subMenuLabel}
                    sx={ selectedIndex === item?.subLink ? { background: '#c1c1c16b' } : {} }
                  >
                    <ListItemButton className={classes.subitemscolor}>
                      <ListItemIcon className={classes.subitemsicon}>
                        {React.createElement(getIconByName(item?.name))}
                      </ListItemIcon>
                      {sidebarOpen && (
                        <ListItemText className={classes.subitemscontent}
                          primary={<Typography variant="body1">{item?.name}</Typography>}
                        />
                      )}
                      {item?.isCollapsible ? (item?.open ? <ExpandLess /> : <ExpandMore />) : null}
                    </ListItemButton>
                  </List>

                  {/* recursive collapse for nested submenu */}
                  {item?.isCollapsible && (
                    <Collapse in={item?.open} timeout="auto" unmountOnExit>
                      {item?.subMenu?.map((subSub) => (
                        <List
                          component="div"
                          disablePadding
                          key={subSub?.name}
                          onClick={() => handleMenuNavigate(subSub?.subLink)}
                          sx={ selectedIndex === subSub?.subLink ? { background: '#c1c1c16b' } : {} }
                        >
                          <ListItemButton className={classes.subitemscolor}>
                            <ListItemIcon className={classes.subitemsicon}>
                              {React.createElement(getIconByName(subSub?.name))}
                            </ListItemIcon>
                            {sidebarOpen && (
                              <ListItemText
                                className={classes.subitemscontent}
                                primary={<Typography variant="body2">{subSub?.name}</Typography>}
                              />
                            )}
                          </ListItemButton>
                        </List>
                      ))}
                    </Collapse>
                  )}
                </div>
              ))}
              </Collapse>
            ) : (
              <></>
            )}
          </List>
        ))}

</section>
    </div>
  )
}

export default Sidebar
